var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCocina(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7CCCC3;}\n\t.st1{fill:#F9F9F9;}\n\t.st2{fill:#E5E9E9;}\n\t.st3{fill:#FFE5BA;}\n\t.st4{fill:#414042;}\n\t.st5{fill:#F1F2F2;}\n\t.st6{fill:#575757;}\n\t.st7{fill:#FCC066;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#F9F7F7;}\n\t.st10{fill:#F46D73;}\n\t.st11{fill:#F14950;}\n\t.st12{fill:#B9C4C4;}\n\t.st13{fill:#FFFFFF;stroke:#141414;stroke-miterlimit:10;}\n\t.st14{fill:#FDB5AC;}\n\t.st15{fill:#E69962;}\n\t.st16{fill:#EBAD81;}\n\t.st17{fill:#F7DEB4;}\n\t.st18{fill:#FAEBD2;}\n\t.st19{fill:#F5F6F6;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -52.414 92.6161)",
    className: "st0",
    cx: 85.6,
    cy: 109.6,
    rx: 83.1,
    ry: 83.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137,158.2c16.2-10,16.7-27.7,16.8-37.2c-0.2,0-0.9,0-4.4,0c-3.5,0-5.2,0-5.2,0c-0.3,1,2.3,19.2-13.3,26.6 c-10.7,5.1-34.6-8.3-34.6-8.3l-6-4.5c-0.2,4.9-4.5,2.2-4.5,2.2c-1.3-0.5-8.5-1.6-10.4,2.3c0,0-10,4.9-20,13.8 c-10.4,9.2-14.7,17.8-15.7,25.4c2.9,1.9,5.9,3.7,9,5.2c0.8-3.6,3-7.6,7.6-12c2.7-2.6,3.4-3.6,5.4-4.8c0,0-1.9,12.3-1.6,21.5 c6.7,2.2,13.8,3.6,21.2,3.9v-55.5h1v55.5c1.1,0,2.3,0.1,3.4,0.1c10.4,0,20.4-1.9,29.6-5.4c-0.8-11.8-2.2-21.1-2.2-21.1 C117,165.4,128.8,163.3,137,158.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.2,137.1v55.5c0.3,0,0.7,0,1,0v-55.5H81.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M117.3,86.3l0.5,47.9c-2.6,0-32.7,0-32.7,0s0.6-45.7-0.3-45.3V56.4C103,56.4,117.3,86.3,117.3,86.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.3,87.3c0,8.5,0,46.9,0,46.9c2.4,0,30.3,0,30.3,0S84,88.5,84.8,88.8V56.4C67.9,56.4,54.2,65.2,54.3,87.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M115.2,103c0,14.2-12.3,26.5-28.9,26.5c-16.6,0-30.1-11.5-30.1-25.7c0-37.2,12.9-38.1,29.5-38.1 C102.3,65.8,115.2,69.6,115.2,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M79.9,99.2c0,1.7-1.4,3-3,3c-1.7,0-3-1.4-3-3c0-1.7,1.4-3,3-3C78.6,96.1,79.9,97.5,79.9,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M78.5,98.4c0,0.7-0.6,1.3-1.3,1.3c-0.7,0-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C77.9,97.2,78.5,97.8,78.5,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M92.7,99.2c0,1.7,1.4,3,3,3c1.7,0,3-1.4,3-3c0-1.7-1.4-3-3-3C94,96.1,92.7,97.5,92.7,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M94.1,98.4c0,0.7,0.6,1.3,1.3,1.3c0.7,0,1.3-0.6,1.3-1.3c0-0.7-0.6-1.3-1.3-1.3C94.7,97.2,94.1,97.8,94.1,98.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M61.9,109.8c0,2.3-1.8,4.1-4.1,4.1c-2.3,0-4.1-1.8-4.1-4.1c0-2.3,1.8-4.1,4.1-4.1 C60.1,105.7,61.9,107.6,61.9,109.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M110.7,109.8c0,2.3,1.8,4.1,4.1,4.1c2.3,0,4.1-1.8,4.1-4.1c0-2.3-1.8-4.1-4.1-4.1 C112.5,105.7,110.7,107.6,110.7,109.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M75.7,89.4c-2.9,0-5.3,1-6.6,2.4c0,0,3.1-1.7,6.6-1.7c3.7,0,6.6,1.7,6.6,1.7C81,90.3,78.5,89.4,75.7,89.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M96.4,89.4c2.9,0,5.3,1,6.6,2.4c0,0-3.1-1.7-6.6-1.7c-3.7,0-6.6,1.7-6.6,1.7C91.1,90.3,93.5,89.4,96.4,89.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 81.2,
    y: 128.4,
    className: "st3",
    width: 9,
    height: 8.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2,106.1l-2-17.7C55,86.9,59,76.3,59,76.3l3.8,3.2C62.7,79.6,62.2,92.2,56.2,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.2,105.7l2.1-19.1c-0.5-1.6-4.9-10.2-4.9-10.2l-5.3,3.6C107.2,80,109.8,92.9,115.2,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M86.2,47.8C80.4,63.8,61.6,60.4,61.6,73c0,0,2.9,6.6,24.6,6.6c21.7,0,23.5-6.6,23.5-6.6 c-0.6-8.6-7.3-8.3-10.3-8.6C87.6,63.1,87.6,44,86.2,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M61,75.5c0,0-0.3-4.2,5-5.7s20.4-4.7,20.3-13.3c0,0,5.3,8-8.4,14.6C66.7,76.5,61.9,79.3,61,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M59.3,76.9c0,0-3-0.5-3.1,6.5c0,0,3.5-4.2,6.2-3.9L59.3,76.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.9,46.2c-0.1,10.8-9.1,19.5-20,19.3c-10.9-0.1-19.7-9-19.5-19.8c0.1-10.8,9.1-19.5,20-19.3 C62.3,26.5,71.1,35.4,70.9,46.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.8,48.5c-1.1,3.8-3.4,7.2-6.7,9.8c-8.5,6.6-20.9,5.1-27.6-3.6c-3.3-4.3-4.6-9.5-4.1-14.4 c-1.8,5.9-0.7,12.6,3.4,17.8c6.7,8.6,19.1,10.2,27.6,3.6C67.7,58.3,70.2,53.5,70.8,48.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,34c0.6,12-6.2,24.3-22,29.7c-5.2,1.8-15,0.6-21,1.3c-40.5,5.4-45.1-10.6-45.9-26.5 c-0.8-15.9,18.4-29.8,43-31.1C114.7,6.2,135.3,18.1,136.1,34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M135.8,34.9c-0.8,8-7.5,14.4-17.5,15.9c-28.9,4.4-36.8-10.9-35.7-21.5c1.1-10.6,13.9-17.9,28.6-16.4 C125.9,14.5,136.9,24.3,135.8,34.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M34.7,46.8c-1.9-1.8-2.2-4.8-0.6-7.7c4.6-8.4,10.1-7.4,12.7-5c2.5,2.4,1.9,7.2-1.4,10.6 C42,48.3,37.3,49.2,34.7,46.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.4,46.5c-2-4.6-3.3-10.3-2.6-15.6c-2.4,7.4-2.2,15.1,1.1,21.1c5.7,10.4,19,24.7,42.5,6.7 C71.9,76.6,57.6,53.9,54.4,46.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M111.6,30.8c0.4,4.5-0.5,9.1-2.9,13.3c-6.2,10.7-20.1,14.3-30.9,8c-5.4-3.1-9-8.1-10.5-13.6 c0.7,7,4.6,13.7,11.2,17.5c10.8,6.3,24.6,2.7,30.9-8C112.5,42.6,113.1,36.4,111.6,30.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M54.3,64.7v23.7c0,0,24.6-15.4,63.1-1.9l-0.5-22.8C116.9,63.7,88.7,44.3,54.3,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.8,114.5c0,0.8-0.6,1.4-1.4,1.4h-63.9c-0.8,0-1.4-0.6-1.4-1.4l0,0c0-0.8,0.6-1.4,1.4-1.4h63.9 C191.2,113.1,191.8,113.7,191.8,114.5L191.8,114.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M150.3,121.5L150.3,121.5C150.3,121.5,150.3,121.5,150.3,121.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.2,121.1c0,0-7-1.3-6.6-3.1c0.5-2.6,7.1,0.4,9.7,0.4c1.8,0,19.2-1.5,19.2,1.1c0,1.8-6,1.6-12.7,1.6H144.2z "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4,
    y: 134.4,
    className: "st10",
    width: 10.8,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.3,
    y: 134.4,
    className: "st11",
    width: 10.1,
    height: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M84.7,136c0,0-3.1,0.5-5.2,4.5c-2.1,3.9-4.4,9.1-4.4,9.1c0.3,0.2,7.2-6.6,8.3-8.3c1.1-1.6,1.3-4.5,1.3-4.5 V136z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M86.2,137.5c0,0-4.5,6.3,11.3,13.9C97.6,151.3,93.2,133.7,86.2,137.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.2,186.3c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C89.2,184.2,90.2,185.2,90.2,186.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.2,173.7c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C89.2,171.6,90.2,172.6,90.2,173.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M90.2,161.9c0,1.2-0.9,2.1-2.1,2.1c-1.2,0-2.1-0.9-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1 C89.2,159.8,90.2,160.7,90.2,161.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M85.7,122.7c6.9,0,9.7-5.9,9.7-11.3H76C76,116.7,79.1,122.7,85.7,122.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M110.4,109.6c0,2.4-2.6,4.4-5.8,4.4c-3.2,0-5.8-2-5.8-4.4c0-2.4,2.6-4.4,5.8-4.4 C107.8,105.2,110.4,107.2,110.4,109.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M60.9,109.6c0,2.4,2.6,4.4,5.8,4.4c3.2,0,5.8-2,5.8-4.4c0-2.4-2.6-4.4-5.8-4.4 C63.5,105.2,60.9,107.2,60.9,109.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.5,87.8 77.6,87.8 74.9,72.1 70.7,87.8 54.3,88.4 56.4,74.1 64.1,67.3 85.4,63.1 110.4,66  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.3,71.3v17.1c0,0,24.6-15.4,63.1-1.9l-0.5-22.8C116.9,63.7,79.4,55.4,54.3,71.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M182.1,99.6c0,8.1-5.5,11.1-19.9,11.9c-14.4,0.8-24.5,0.6-28.3-12.5c-2.9-9.9,1.6-20.7,15.9-21.5 C164.2,76.8,182.1,88.6,182.1,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M179.2,98.4L179.2,98.4c-0.4,0.1-0.9,0.2-1.3,0.4c-2.9,1.2,0.9-3.3,0.9-3.3s-4.9-3.3-1.8-2.9 c0.4,0.1,0.9,0.1,1.4,0.1l0,0c0,0-7.2-6.6-18.3-5.3c-0.1,0-0.2,0-0.4,0c-0.1,0-0.1,0-0.2,0c0,0,0,0,0,0v0 c-6.1,1-10.5,6.3-9.7,12.1c0.8,5.8,6.4,9.8,12.6,9.1l0,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.4-0.1,0.8-0.1,1.2-0.2 C174.4,106.2,179.2,98.4,179.2,98.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M189.7,95.2c0.1-0.4,2.4-1.4,2.2-2.7c-0.3-1.3,2-3.8,2-3.8c-0.5,0-1.1,0.2-1.7,0.4 c-3.7,1.6-8.9,3.6-13.7,3.5c-0.5,0-0.9,0-1.4-0.1c-3.1-0.4,1.8,2.9,1.8,2.9s-3.7,4.5-0.9,3.3c0.4-0.2,0.8-0.3,1.3-0.4 c4.6-1.5,10.1-1,14.2-0.5c0.4,0,0.8,0,1.1,0c-0.6-0.8-1.2-1.8-1.4-1.9C192.7,95.7,189.6,95.6,189.7,95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M197.4,92.8c-0.2-1.5-0.9-4.3-3.5-4.2c0,0-2.3,2.6-2,3.8c0.3,1.3-2.1,2.3-2.2,2.7c-0.1,0.4,3,0.5,3.4,0.7 c0.2,0.2,0.8,1.1,1.4,1.9C197.7,97.7,197.6,94.5,197.4,92.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M130.4,67.7c-11.7,12.3-11.2,31.9,1.1,43.6l42.5-44.7C161.7,54.9,142.2,55.4,130.4,67.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M125.8,63.3c-2.4,2.5-2.2,6.5,0.4,8.9c2.6,2.5,6.6,2.4,8.9,0c2.4-2.5,2.2-6.5-0.4-8.9 C132.1,60.8,128.1,60.8,125.8,63.3z M133.7,70.9c-1.7,1.7-4.4,1.7-6.3,0c-1.8-1.7-1.9-4.5-0.3-6.2c1.6-1.7,4.4-1.7,6.2,0 C135.2,66.3,135.4,69.1,133.7,70.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M166.3,72.8l4.8-6.6c-13.8-10-33.1-7-43.1,6.8c-1.3,1.7-2.3,3.5-3.2,5.4C135.9,67.8,152.7,65.4,166.3,72.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCocina);
export default __webpack_public_path__ + "static/media/cocina.88160d4edb6aba3cd23500dee12c93bc.svg";
export { ForwardRef as ReactComponent };